module.exports = __webpack_public_path__ + "static/img/tooltip-constellation-revisit-partitions.6f6e44d.png";